import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Table, Tag } from "antd";
import { showConfirmDlgWidget } from "components/ConfirmDlgWidget/showConfirmDlgWidget";

function TableWidget(props) {
  const [dataSource, setDataSource] = useState([]);
  const { dataList, onUpdateAction, onDeleteAction } = props;

  useEffect(() => {
    if (dataList !== undefined) {
      setDataSource([...dataList.map((info) => ({ ...info, key: info.id }))]);
    }
  }, [dataList]);
  if (dataList === undefined) return <div />;

  const columns = [
    { title: "Name", dataIndex: "name", render: (t) => <span style={{ fontWeight: 600 }}>{t}</span> },
    {
      title: "Discount",
      dataIndex: "discount_percent",
      align: "center",
      render: (t) => `${Number(t || 0).toFixed(2)}%`,
    },
    { title: "Default payment terms", dataIndex: "default_payment_terms" },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      render: (t) => <Tag color={t === "1" ? "green" : "default"}>{t === "1" ? "Active" : "Hidden"}</Tag>,
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (text, record) => (
        <div>
          <a style={{ color: "var(--blueColor)", marginLeft: 12 }} onClick={() => onUpdateAction(record)}>
            Edit
          </a>
          <a
            style={{ color: "var(--redColor)", marginLeft: 16 }}
            onClick={async () => {
              const res = await showConfirmDlgWidget({
                title: "Delete Confirmation",
                content: `Delete the "${record.name}" price tier?`,
              });
              if (res == false) return;
              onDeleteAction(record);
            }}
          >
            Delete
          </a>
        </div>
      ),
    },
  ];

  return (
    <div className="list-table">
      <Table pagination={false} columns={columns} dataSource={dataSource} />
    </div>
  );
}

export default withRouter(TableWidget);
